import { render, staticRenderFns } from "./DoctorModal.vue?vue&type=template&id=1ca2e99a&"
import script from "./DoctorModal.vue?vue&type=script&lang=js&"
export * from "./DoctorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports